import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFLookupBankAccountVendorCustomer } from "src/components/Shared/NewForms/NFLookupBankAccountVendorCustomer";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import { NFLookupEmployee } from "src/components/Shared/NewForms/NFLookupEmployee";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";

const PaymentRequestIssuingLoanToEmployee = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupEmployee title={t("Employee")} fieldName="employeeId" required />
        </Col>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccountVendorCustomer fieldName="payerAccountId" title={t("PayerAccount")} />
        </Col>
        <Col sm={6}>
          <NFLookupCashRegister fieldName="cashAccountId" title={t("CashAccount")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput title={t("Amount")} fieldName={"amount"} required />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required />
        </Col>
      </Row>
    </>
  );
};

export default PaymentRequestIssuingLoanToEmployee;
